module.exports = "/images/vendor/flag-icon-css/flags/1x1/ga.svg?33d27fe1d14e7a989255f6c1d24e5882";